import { render } from "./WithdrawLimitCard.vue?vue&type=template&id=ade7a344"
import script from "./WithdrawLimitCard.vue?vue&type=script&lang=js"
export * from "./WithdrawLimitCard.vue?vue&type=script&lang=js"

import "./WithdrawLimitCard.vue?vue&type=style&index=0&id=ade7a344&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__